import SockJS from 'sockjs-client'
import eventBus from './plugins/eventbus';
import store from './store/index';
function needNotification() {
  return new Promise((resolve, reject) => {
    if (Notification.permission !== 'granted') {
      Notification.requestPermission().then(status => {
        if (status === 'granted') return resolve()
        return reject()
      })
    } else {
      return resolve()
    }
  })
}
const appName = store.state.appName
function newNotice(options) {
  return new Notification(appName, options)
}
export default class Wser {
  _wsInstance = null
  onopen = null
  onmessage = null
  onclose = null
  constructor() {}
  open(url) {
    needNotification().then(()=>{
      console.log(`系统通知已开启！`);
    }).catch(()=>{
      console.log(`系统通知开启失败！`);
    }).finally(() => {
      if (!this._wsInstance) {
        this._wsInstance = new SockJS(url)
        this._wsInstance.onopen = () => {
          console.log('信息推送服务准备就绪。')
          if (this.onopen) this.onopen()
        }
        this._wsInstance.onmessage = e => {
          const data = JSON.parse(e.data)
          // console.log('++++++++++++++++onmessage',data);
          data.forEach(item => {
            if(item.alert){
              newNotice({body: item.message})
            }
            if(item.type === 2){
              eventBus.emit('updateProduct')
            }
            if(item.type === 5){
              eventBus.emit('updateOrder')
            }
          })
          if (this.onmessage) this.onmessage(e.data)
        }
        this._wsInstance.onclose = () => {
          if (this.onclose) this.onclose()
          console.log('信息推送服务已关闭。')
        }
      } else {
        console.log('信息推送服务已开启,无需再次开启。')
      }
    })
    
  }
  close() {
    console.log('关闭消息推送')
    this._wsInstance.close()
  }
}
